import React, { memo } from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const MoonIcon = ({ size = defaultSize, ...props }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    />
  </svg>
);

MoonIcon.propTypes = {
  ...sizePropsTypes,
};

export default memo(MoonIcon);
